import { IBuilderEmailDocument } from './builderDocument';
import { AutomaticTextPlaceholders } from './textSubstitution';
import { Section, isTextSection, isButtonSection } from './sections';

export class BuilderEmailDocumentInspector {
    public hasSubstitutionContent(document: IBuilderEmailDocument): boolean {
        return this.hasAutomaticLocationTextSubstitutionContent(document);
    }

    public hasTextSubstitutionContent(document: IBuilderEmailDocument, ...keys: AutomaticTextPlaceholders[]): boolean {
        for (const section of document.sections) {
            if (isTextSection(section) && keys.some(key => section.html.includes(`{${key}}`))) {
                return true;
            } else if (isButtonSection(section) && keys.some(key => section.text.includes(`{${key}}`))) {
                return true;
            }
        }

        return false;
    }

    public getSectionById(document: IBuilderEmailDocument, sectionId: number): Section | undefined {
        for (const section of document.sections) {
            if (section.id === sectionId) {
                return section;
            }
        }
        return undefined;
    }

    protected hasAutomaticLocationTextSubstitutionContent(document: IBuilderEmailDocument): boolean {
        return this.hasTextSubstitutionContent(
            document,
            AutomaticTextPlaceholders.Location,
            AutomaticTextPlaceholders.Phone,
            AutomaticTextPlaceholders.Address,
            AutomaticTextPlaceholders.AddressSingleLine,
            AutomaticTextPlaceholders.Website,
        );
    }
}
